import TemplatePagePartialsRoutes from './routes'

const TemplatePagePartials = () => (
  <TemplatePagePartialsRoutes />
)

export default TemplatePagePartials
